import { jsx as _jsx } from "react/jsx-runtime";
import * as S from './TableLink.css';
const TableLink = (props) => {
    const { noPadding = false, display } = props;
    return (_jsx(S.Link, Object.assign({}, props, { nopadding: noPadding.toString(), display: display })));
};
export default TableLink;
